var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[(_vm.logoSource && !_vm.urlError)?_c('img',{staticClass:"logo-image",attrs:{"src":_vm.logoSource,"alt":_vm.companyName},on:{"error":() => _vm.urlError = true}}):_vm._e(),(_vm.urlError)?_c('div',{staticClass:"logo-fallback-text"},[_vm._v(" "+_vm._s(_vm.companyName)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }